import { render, staticRenderFns } from "./TabNeighbors.vue?vue&type=template&id=0ac95770&"
import script from "./TabNeighbors.vue?vue&type=script&lang=js&"
export * from "./TabNeighbors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports